import React, { useState } from "react";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";

//@ts-ignore
import styled from "styled-components";

interface IProps {
  onSubmit: (value: string) => void;
}

const CertificateForm: React.FC<IProps> = ({ onSubmit }) => {
  const [inputValue, setInputValue] = useState("EPI_");
  const [spinner, setSpinner] = useState(false);
  const [formError, setFormError] = useState(false);

  const submit = async () => {
    if (inputValue === "EPI_") {
      setFormError(true);
      return;
    }
    setSpinner(true);
    await onSubmit(inputValue);
    setSpinner(false);
  };
  return (
    <FormWrapper>
      <form noValidate autoComplete="off">
        <TextField
          id="outlined-basic"
          label="EPI NUMBER"
          variant="standard"
          value={inputValue}
          error={formError}
          onChange={(e) => {
            let value = `EPI_${e.currentTarget.value.replace("EPI_", "")}`;
            setFormError(false);
            setInputValue(value);
          }}
        />
        {formError && <ErrorText>Epi Number can't be empty</ErrorText>}
      </form>
      <CButton onClick={submit} variant="contained" color="primary">
        {spinner ? (
          <CircularProgress style={{ color: "white" }} />
        ) : (
          "Generate Certificate"
        )}
      </CButton>
    </FormWrapper>
  );
};

export default CertificateForm;

const CButton = styled(Button)`
  && {
    color: white;
    border-radius: 1px;
    text-transform: capitalize;

    @media (max-width: 960px) {
      width: 12rem;
    }
  }
`;

const ErrorText = styled.div`
  margin-top: 1rem;
  color: red;
  font-size: small;
`;
const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 2em;
  margin-bottom: 2em;
  & > form > * {
    width: 500px;
  }

  & > button {
    margin-top: 10px;
    width: 300px;
    height: 50px;
    border-radius: 20px;
    font-weight: bold;
  }

  @media (max-width: 960px) {
    flex-direction: column;
    & > form > * {
      width: 100%;
    }
    margin-top: 5.5rem;
    & > button {
      margin-top: 10px;
    }
  }
`;
